import { useEffect } from "react"
import { IntercomProjectId } from "@equipmentshare/heaper"

import { IS_PROD } from "@app/services/env"

export const IntercomInitScript = () => {
	useEffect(() => {
		const appId = IS_PROD ? IntercomProjectId.Production : IntercomProjectId.Staging
		const intercomSettings = {
			app_id: appId,
			alignment: "left",
			horizontal_padding: -10,
			vertical_padding: 80,
		}

		const script = document.createElement("script")
		script.innerHTML = `
  			(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',${JSON.stringify(intercomSettings)});}else{var d=document;var
  i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var
  s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${appId}';var
  x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else
  if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
  		`
		document.head.appendChild(script)

		return () => {
			document.head.removeChild(script)
		}
	}, [])

	return null
}
